import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { reportNameMessages } from '../../reports/constants';

interface Props {
  reportType: string;
}

export function AodReportType({ reportType }: Props) {
  const { formatMessage } = useIntl();
  const message = reportNameMessages[reportType];
  const label = message ? formatMessage(message) : reportType;

  return <Chip color="info" label={label} />;
}
